import ChargeHelper from 'features/Charge/chargeHelper';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';

DialogAssignVehicleView.propTypes = {
  identifier: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAssignVehicleView({ identifier, onCancel, onDone }) {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [loading, setLoading] = useState(false);

  const dropdownVehicleEl = useMemo(() => (
    <CustomDropdown2
      id="vehicleId_assign"
      name="vehicleId_assign"
      ignoreConfirmClick={true}
      toggleElement={
        <button
          className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between${readyToValidate && !selectedVehicle ? ' border-danger' : ''}`}
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
          type="button"
        >
          {selectedVehicle?.name ?? 'Chọn xe'}
        </button>
      }
      selectedValue={selectedVehicle}
      dropdownMenuItems={[{ name: 'Xe', role: 'VEHICLE' }]}
      getSubItems={async (item) => {
        const data = await ChargeHelper.API.Vehicle.requestGetVehicleList({
          page: item?.page || 0,
          limit: 10,
          q: item?.q || '',
          identificationCode: false,
        });
        return {
          values: data.vehicles?.map((row) => ({
            id: row?.vehicleId,
            name: row?.plate,
            item: row,
          })),
          total: data.total,
        };
      }}
      dropdownMenuStyle={{ maxHeight: '30vh' }}
      dropdownMenuClassName="overflow-auto w-100"
      onChange={(value) => setSelectedVehicle(value)}
      isDropdownForm={true}
      titleSearchable={true}
      searchable={true}
      searchFormClassName="mx-3 my-1 search-form-border"
      defaultValue={{ name: 'Xe', role: 'VEHICLE' }}
      footerEl={
        <div
          className="p-4 position-sticky sticky-bottom bg-white"
          style={{ borderTop: `1px solid ${AppColors.gray[300]}` }}
        >
          {UIHelper.buildNegativeButton('Bỏ chọn', () => setSelectedVehicle(null))}
        </div>
      }
    />
  ), [selectedVehicle, readyToValidate]);

  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!selectedVehicle) {
      ToastHelper.showError('Vui lòng chọn xe');
      return;
    }
    setLoading(true);
    try {
      const result = await ChargeHelper.API.Identifier.requestUpdateIdentifier(
        identifier?.vehicleIdentityId,
        { vehicleId: selectedVehicle.id }
      );
      if (result === true) {
        ToastHelper.showSuccess('Gán mã định danh thành công');
        if (onDone) onDone();
      } else {
        ToastHelper.showError(_.isString(result) ? result : 'Gán mã định danh thất bại');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center px-5 pt-5 pb-2">
        <div className="mb-4">
          <img src={AppResource.images.dialogIcons.dialogIdentifierAssign} alt="" />
        </div>
        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Gán mã định danh
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Chọn xe cần Gán mã MAC/EVCC và nhấn xác nhận để hoàn thành
        </span>
      </div>

      <div className="px-5 pt-4 pb-5">
        <div>{UIHelper.buildFormLabel('Chọn xe', true)}</div>
        {dropdownVehicleEl}
        {readyToValidate && !selectedVehicle && (
          <span className="text-danger" style={{ fontSize: '0.875rem' }}>
            Vui lòng chọn xe
          </span>
        )}
      </div>

      <div
        className="d-flex align-items-center gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Xác nhận', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogAssignVehicleView;
